export const elevenLabsOptions = {
  voiceId: "1aJyZpkt0vxhGPBnPyrs",
  modelId: "eleven_multilingual_v2",
  outputFormat: "mp3_44100_128",
  voiceSettings: {
    stability: 0,
    similarity_boost: 1.0,
    use_speaker_boost: true,
    speed: 1.0,
  },
};